import { createStyles } from '@mantine/core';
import { IconKey } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';

const useStyles = createStyles((theme) => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.other.spacing._2,
    color: theme.colors.green[5],
    whiteSpace: 'nowrap',
  },
}));

type PickControlBadgeProps = {
  variant?: 'pickControl' | 'makesThePicks';
};

export function PickControlBadge({ variant = 'pickControl' }: PickControlBadgeProps) {
  const { t } = useTranslation('group');
  const { classes, theme } = useStyles();

  return (
    <span className={classes.badge}>
      <IconKey
        size={16}
        color={theme.colors.green[5]}
        className="tabler-icon-key"
        aria-hidden="true"
      />
      <Text tag="div" variant="subhead-small">
        {variant === 'makesThePicks'
          ? t('shareholders.makesThePicks')
          : t('shareholders.pickControl')}
      </Text>
    </span>
  );
}
